import { IconBaseProps } from 'react-icons';

import { LuTags } from 'react-icons/lu';

const stylesheet = {
  wrapper: 'inline-flex',
};

const MIRROR_STYLE = { transform: 'scaleX(-1)' } as const;

export function MirroredTagsIcon({
  className,
  ...props
}: Readonly<IconBaseProps>) {
  return (
    <span className={stylesheet.wrapper} style={MIRROR_STYLE}>
      <LuTags {...props} className={className} />
    </span>
  );
}
